import React, { useCallback, useState } from 'react';
import { Tab } from '@mui/material';
import { HeadlessPageWrapper } from 'templates/PageWrapper/PageWrapper';
import { StyledPaper } from 'pages/ContactsPage/Contacts.styles';
import { StyledTabList } from 'molecules/Card/Card.styles';
import { StyledTabPanel } from 'organisms/CompanyInvoicesTabs/CompanyInvoicesTabs.styles';
import { TabContext, TabPanel } from '@mui/lab';
import ProjectsPage from 'organisms/Projects';
import ZohoProjects from 'organisms/Projects/ZohoProjects';
import Expense from 'organisms/Expense';

type TabType = 'projects' | 'zohoProjects' | 'expenses';

const ProjectPage = () => {
  const [selectedTab, setSelectedTab] = useState<TabType>('projects');

  const handleChangeTabs = useCallback(
    (event: React.SyntheticEvent, newValue: TabType) => {
      setSelectedTab(newValue);
    },
    []
  );

  function a11yProps(index: number) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  }

  return (
    <HeadlessPageWrapper isRelative>
      <StyledPaper>
        <TabContext value={selectedTab}>
          <StyledTabList
            onChange={handleChangeTabs}
            aria-label="Projects and Zoho Projects tabs"
            variant="fullWidth"
          >
            <Tab
              label="Integrated Projects"
              {...a11yProps(1)}
              className={selectedTab === 'projects' ? '.active' : ''}
              value="projects"
            />
            <Tab
              label="Zoho Projects"
              {...a11yProps(0)}
              className={selectedTab === 'zohoProjects' ? '.active' : ''}
              value="zohoProjects"
            />
            <Tab
              label="Projects Expense"
              {...a11yProps(0)}
              className={selectedTab === 'expenses' ? '.active' : ''}
              value="expenses"
            />
          </StyledTabList>
          <StyledTabPanel value="projects" sx={{ p: 0 }}>
            <ProjectsPage />
          </StyledTabPanel>
          <TabPanel value="zohoProjects" sx={{ p: 0 }}>
            <ZohoProjects />
          </TabPanel>
          <TabPanel value="expenses" sx={{ p: 0 }}>
            <Expense />
          </TabPanel>
        </TabContext>
      </StyledPaper>
    </HeadlessPageWrapper>
  );
};

export default ProjectPage;
